import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

export const headerHeight = "64px";
export const footerHeight = "30px";
const contentHeight = `calc(100vh - ${headerHeight} - ${footerHeight} )`;
const contentAndBottomHeight = `calc(100vh - ${headerHeight} ) `;

const PageLayout = ({
  mainElement,
  rightElement,
  isLeftSideScrollable,
  isRightSideScrollable,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: contentAndBottomHeight,
      }}
    >
      {/* Main Content Area */}
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={1} sx={{ height: contentHeight }}>
          {/* Column 1 (Left) */}
          <Grid item xs={12} sm={8}>
            <Box
              sx={{
                height: contentHeight,
                overflowY: isLeftSideScrollable ? "auto" : "visible",
                flexGrow: 1,
                p: "2px",
                border: "1px solid gray",
              }}
            >
              {/* Render the mainElement here */}
              {mainElement}
            </Box>
          </Grid>

          {/* Column 2 (Right) */}
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                height: contentHeight,
                overflowY: isRightSideScrollable ? "auto" : "visible",
                flexGrow: 1,
                pl: "2px",

                border: "1px solid gray",
              }}
            >
              {/* Render the mainElement here */}
              {rightElement}
            </Box>
          </Grid>
        </Grid>
      </Box>
      {/* Fixed Footer */}
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          width: "100%",
          height: footerHeight,
          bgcolor: "lightGreen",
          color: "white",
          textAlign: "center",
          zIndex: 10,
        }}
      ></Box>
    </Box>
  );
};

export default PageLayout;
